import { useTheme } from "@emotion/react";
import { Button, Stack, Typography } from "@mui/material"
import CenteredText from "components/CenteredText"
import Page from "components/Page"
import PepperKissing from "assets/images/pepper_kissing.png"
import AlzaVolume from "components/AlzaVolume";
import { useHistory } from "react-router";
import { useSetRecoilState } from "recoil";
import { useEffect } from "react";

import { timerRunningAtom } from "lib/globalState";

const Piacere = () => {
    const theme = useTheme();
    const history = useHistory();

    const setTimerRunning = useSetRecoilState(timerRunningAtom);

    useEffect(() => {
        setTimerRunning(true);
        console.log('Started timer');
    }, [])

    return (<Page bg={theme.palette.background.paper} syncNavCommand="PIACERE_PEPPER" audioFile="/sounds/0.mp3">
        <div style={{
            display: 'flex',
            flex: 1,
            backgroundPositionX: 'center',
            backgroundPositionY: '10vh',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${PepperKissing})`,
        }}>
            <div style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column-reverse',
                background: 'linear-gradient(0deg, rgb(0, 58, 92) 0%, rgb(0, 66, 105) 50%, rgba(0, 0, 0, 0) 85%)'
            }}>
                <Stack spacing={1} sx={{
                    display: 'flex',
                    flex: 0.6
                }}>
                    <CenteredText>
                        <Typography variant="h2">Piacere,</Typography>
                        <Typography variant="h5" sx={{ paddingInline: '1.1rem', lineHeight: '2rem' }}>
                            mi chiamo Pepper e sono un robot umanoide.
                        </Typography>
                    </CenteredText>
                    <AlzaVolume />
                    <CenteredText>
                        <Button variant="outlined" color="white" onClick={() => history.push('/scelta_iniziale')}>Inizia</Button>
                    </CenteredText>
                </Stack>
            </div>
        </div>
    </Page>)
}
export default Piacere